import React from 'react';
import { Box, Dialog, Typography } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useModal } from '../../../../../store/ModalProvider';
import CustomButton from '../../CustomButton/CustomButton';
import type { StatusMessageModalData } from '../../../../../types/modal';

const CustomModalSuccessMessage: React.FC = () => {
  const { isOpen, closeModal, modalData, modalHandlers } = useModal();
  const successData = modalData as StatusMessageModalData | undefined;
  const [handleNext] = modalHandlers ?? [];

  if (!successData) {
    return null;
  }

  const message =
    successData.message ?? 'Escala de 02/05/2024 enviada com sucesso.';
  const primaryLabel = successData.primaryLabel ?? 'Ok';

  const handleAdvance = () => {
    if (typeof handleNext === 'function') {
      handleNext(successData);
      return;
    }
    closeModal();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleAdvance}
      sx={{ pointerEvents: 'auto', zIndex: 2000 }}
      PaperProps={{
        sx: {
          width: 'min(444px, 100%)',
          borderRadius: '4px',
          backgroundColor: '#FFFFFF',
          boxShadow:
            '0 6px 30px 5px rgba(9, 32, 86, 0.12), 0 16px 24px 2px rgba(9, 32, 86, 0.14), 0 8px 10px -5px rgba(9, 32, 86, 0.2)',
          overflow: 'hidden',
          zIndex: 2001,
        },
      }}
    >
      <Box
        sx={{
          background:
            'linear-gradient(180deg, rgba(22, 197, 61, 0.1) 0%, rgba(22, 197, 61, 0) 100%)',
          paddingTop: '16px',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '16px',
              borderRadius: '999px',
              background:
                'linear-gradient(65.12deg, #16C53D 57.78%, #00A5FF 115.35%)',
            }}
          >
            <CheckCircleRoundedIcon
              sx={{ fontSize: 35, color: '#FFFFFF' }}
            />
          </Box>
        </Box>
        <Box sx={{ padding: '16px 24px' }}>
          <Typography
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontSize: '16px',
              fontWeight: 600,
              lineHeight: 1.75,
              letterSpacing: '0.15px',
              color: '#092056',
            }}
          >
            {message}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '8px',
            padding: '8px',
          }}
        >
          <CustomButton
            variant="contained"
            onClick={handleAdvance}
            sx={{
              padding: '6px 16px',
              borderRadius: '4px',
              fontSize: '14px',
              fontWeight: 600,
              lineHeight: '24px',
              textTransform: 'none',
              background: '#092056',
              color: '#FFFFFF',
              '&:hover': {
                background: '#08204F',
              },
            }}
          >
            {primaryLabel}
          </CustomButton>
        </Box>
      </Box>
    </Dialog>
  );
};

export default CustomModalSuccessMessage;
